<template>
    <el-dialog
        title="添加设备"
        :visible.sync="visible"
        width="400px"
        :before-close="befclose">
        <div class="bm bm-ver choseBtn bm-ac">
           <el-button plain class="btn" @click="current='0'" :class="{'btn-border':current == 0}"><span v-show="current==0"  class="bm bm-img"></span>现使用设备</el-button>
           <el-button plain class="btn" @click="current='1'" :class="{'btn-border':current == 1}"><span v-show="current==1" class="bm bm-img"></span>增补新的设备</el-button>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="previousStep" size="small">上一步</el-button>
            <el-button type="primary" @click="nextStep" size="small">下一步</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { crmApi } from "@/services";
const R = require("ramda");
export default {
    props: {
        visible: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            current: '0',
            keywords: "",
            info: {},
            param: {
                projectStatus: "项目状态",
                rawType: "原料旧注册分类",
                dosageType: "剂型",
                domain: "领域",
                progress: "当前进度"
            },
            
        };
    },
    watch: {
    },
    methods: {
        previousStep() {
            this.$emit("previousStep",this.current);
        },
        nextStep() {
            this.$emit("nextStep",this.current);
        },
        befclose() {
            this.$emit("addClose");
        },
        choseCurrent(e){
            this.current=e;
        }
    }
};
</script>
<style lang="scss" scoped>
.el-dialog__wrapper {
    /deep/.el-dialog__header {
        padding: 21px 0px 18px 23px;
        border-bottom: 1px solid #dcdfe5;
    }
    /deep/.el-dialog__title {
        color: #323232;
    }
    /deep/.el-dialog__body {
        padding: 10px 20px; 
    }
    .choseBtn{
        .btn{
            width: 70%;
            margin: 10px;
            position: relative;
            background: #f5f6fb;
            border-radius: 0;
            border: 0;
            span{
                width: 15px;
                height: 15px;
                // background: red;
                background-image: url(../../asserts/img/btn_xuanzhong.png);
                position: absolute;
                z-index: 100;
                top: -1px;
                right: -1px;
            }
        }
        .btn-border{
            border: 1px solid #409eff;
        }

    }
}
</style>
